<dsy-button
  class="link-button"
  [ngClass]="'link-button--' + size"
  variant="link"
  [iconSide]="'right'"
  [iconName]="'chevron_right'"
  [iconLibrary]="'material'"
  [iconSize]="'1rem'"
  (click)="openLink()"
  (rightClick)="rightClick()"
  button-style="text-decoration: none; padding: 0;"
>
  <span class="link-button__text">{{ link().text }}</span>
</dsy-button>
